import React from 'react'
import { StatCardMetaProps } from '../data/types'
import { Card } from './ui/Card'

type Props = {
    meta: StatCardMetaProps
}

export const StatCard = (props: Props) => {
    const { meta } = props

    return (
        <Card className="p-6">
            <h3 className="text-gray-500 dark:text-gray-400 text-sm font-medium mb-2">
                {meta.label}
            </h3>
            <p className="text-4xl font-bold text-gray-900 dark:text-white">
                {meta.count}
            </p>
        </Card>
    )
}
